import { makeClassName } from '@siteless/util';

const ArrowUpRightIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: unknown;
}) => (
  <svg
    className={makeClassName('ArrowUpRightIcon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...rest}
  >
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="7"
      y1="17"
      x2="17"
      y2="7"
    />
    <polyline
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="7 7 17 7 17 17"
    />
  </svg>
);

export default ArrowUpRightIcon;
